import { Environment } from '../../../environment';
import { Api } from '../axioscadastro';
import { v4 as uuidv4 } from 'uuid';
export interface IListagemCredito {
   idcredito: string,
   fabrica: string,
   cliente: string,
   emissao: Date,
   valor: number,
  }
export interface IDetalheCredito {
    idcli:string,
    idfabrica:string,
    emissao:Date,
    historico:string,
    valor: number,
}
type TotalCount = {
    data: IListagemCredito[];
    totalCount: number;
}
const getAll = async (pagina = 1, filter = '', ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/credito?page=${pagina}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      }; }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }};
const getById = async (id: string): Promise<IDetalheCredito | Error> => {
  try {
    const { data } = await Api.get(`/credito/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }};
const create = async (dados: IDetalheCredito): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheCredito>('/credito',  {idcredito: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }};
const updateById = async (id: string, dados: IDetalheCredito): Promise<void | Error> => {
  try {
    await Api.put(`/credito/${id}`, dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/credito/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }};
const getAllList = async (id = '', ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/credito?limit=${Environment.LIMITE_DE_LINHAS}&tipo=descricao` : `/produtoslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }};
export const CreditoService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAllList,
};